import { CHAR_LIMIT_WHEN_ENABLED } from './constants.tsx';

export const isUnsubmittedValueTooLong = (unsubmittedValue: string): boolean =>
	unsubmittedValue.length > CHAR_LIMIT_WHEN_ENABLED;

export const isValidUrl = (url: string): boolean => {
	// empty string is valid
	if (url === '') return true;

	try {
		new URL(url);
		return true;
	} catch (e) {
		return false;
	}
};
